import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=dd72b05c&"
import script from "./Employment.vue?vue&type=script&lang=js&"
export * from "./Employment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports